function Team() {
  return (
    <div>
      <h1>Teams</h1>
    </div>
  );
}

export default Team;
